import { Avatar, AvatarImage, Text, VStack } from '@vidahealth/vida-ui';

import { type Program } from '@/modules/api';
import { SelectableRow } from '@/modules/ui';

type ProgramSelectableRowProps = {
  program: Program;
  isSelected: boolean;
  onSelect: (uuid: string) => void;
};

/**
 * Private to ProgramMatchingScreen — a single selectable program row (icon
 * avatar + title + overview) used for both the recommended item and the
 * other-options list.
 */
export function ProgramSelectableRow({ program, isSelected, onSelect }: ProgramSelectableRowProps) {
  const imageUri = program.icon || program.image;

  return (
    <SelectableRow
      isSelected={isSelected}
      selectionRole='radio'
      onPress={() => onSelect(program.uuid)}
      accessibilityLabel={program.title}
      testID={`program-matching-program-${program.uuid}`}
    >
      <Avatar size='lg' className='bg-[#FDF6EE]'>
        {imageUri ? <AvatarImage source={{ uri: imageUri }} alt={program.title} /> : null}
      </Avatar>
      <VStack space='xs' className='flex-1'>
        <Text size='md' weight='semibold' className='text-typography-900'>
          {program.title}
        </Text>
        {program.overviewDescription ? (
          <Text size='sm' className='text-typography-600'>
            {program.overviewDescription}
          </Text>
        ) : null}
      </VStack>
    </SelectableRow>
  );
}
